import React from 'react';
import Technologies from './Technologies';

const TechnologiesPage: React.FC = () => {
  return (
    <div className="py-20">
      <div className="container mx-auto px-4">
        <Technologies />
      </div>
    </div>
  );
};

export default TechnologiesPage;